import Vue from 'vue';
import * as types from './action-types';
import {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONMESSAGE,
  SOCKET_NEWMESSAGE,
  SOCKET_ONERROR,
  SET_SOCKET,
  SET_RECONNECTION,
  SET_RECONNECTION_TIMEOUT,
} from '@/store/modules/socket/mutation-types';


function closeSocket({ state, commit }) {
  commit('SET_RECONNECTION', false);
  clearTimeout(state.reconnectionTimeoutId);
  if (state.socket) {
    state.socket.onclose = null;
    state.socket.close();
  }
}

function openSocket(store) {
  const { state, commit } = store;
  closeSocket(store);
  commit(SET_RECONNECTION, true);
  commit(SET_SOCKET, new WebSocket(state.connectionUrl));
  state.socket.onopen = (e) => {
    commit(SOCKET_ONOPEN, e);
    if (state.credentials) {
      state.socket.send(JSON.stringify(state.credentials));
    } else {
      console.error('Socket is connected without credentials set !');
    }
  };

  state.socket.onmessage = (e) => {
    commit(SOCKET_ONMESSAGE, e);
    commit(SOCKET_NEWMESSAGE, true);
    Vue.nextTick(() => {
      commit(SOCKET_NEWMESSAGE, false);
    });
  };

  state.socket.onerror = (e) => {
    commit(SOCKET_ONERROR, e);
  };

  state.socket.onclose = (e) => {
    commit(SOCKET_ONCLOSE, e);
    if (state.reconnection) {
      commit(SET_RECONNECTION_TIMEOUT, setTimeout(() => { openSocket(store); }, 2500));
    }
  };
  return state.socket;
}

export default {
  [types.OPEN_SOCKET](store) {
    return openSocket(store);
  },

  [types.CLOSE_SOCKET](store) {
    return closeSocket(store);
  },

  [types.SEND_MESSAGE]({ state }, params) {
    if (state.socket && state.isConnected) {
      const message = (params instanceof Object ? params : { msg: params });
      if (state.debug) {
        console.log('Socket send:', message);
      }
      state.socket.send(JSON.stringify(message));
    }
  },
};
